/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Choose_GroupsInputs */

const en_users_form_choose_groups = /** @type {(inputs: Users_Form_Choose_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose user groups`)
};

const pt_br2_users_form_choose_groups = /** @type {(inputs: Users_Form_Choose_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha os grupos do usuário`)
};

/**
* | output |
* | --- |
* | "Choose user groups" |
*
* @param {Users_Form_Choose_GroupsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_choose_groups = /** @type {((inputs?: Users_Form_Choose_GroupsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Choose_GroupsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_choose_groups(inputs)
	return pt_br2_users_form_choose_groups(inputs)
});